import { css } from 'styled-components';
import { theme } from '@styles/theme.styles';

export const ThemeGlobals = css`

    html {
        font-size: 62.5%; // 10px => setting this for rem / em (1rem = 10px)
    }

    *, body {
        box-sizing: border-box;
    }

    body {
        margin: 0;
        padding: 0;
        color: ${theme.colors.bodyText};
        font-family: ${theme.fonts.base};
    }

    h1, h2, h3, h4, h5, h6 {
        font-family: ${theme.fonts.header}, ${theme.fonts.fallbacks};
    }

    img {
        max-width: 100%;
        height: auto;
        vertical-align: top;
    }

    button {
        background-color: transparent;
        outline: none;
        border: none;
    }

    a {
        color: inherit;
    }
    
    // fix gatsby image blink on safari
    /* .gatsby-image-wrapper img,
    .gatsby-image-wrapper > div {
        transition: opacity 500ms ease 0s !important;
    } */
`